(() => {
  if (window.daCustomerPrivacyInitialized) return;
  window.daCustomerPrivacyInitialized = true;
  let privacyPromise;
  let previousFocus;
  const dialog = document.querySelector('[data-da-privacy-dialog]');
  const form = dialog?.querySelector('[data-da-privacy-form]');
  const fields = dialog?.querySelector('[data-da-privacy-fields]');
  const status = dialog?.querySelector('[data-da-privacy-status]');

  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) return Promise.resolve(window.Shopify.customerPrivacy);
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) {
        reject(new Error('Privacy API unavailable'));
        return;
      }
      const timeout = window.setTimeout(() => reject(new Error('Privacy API timeout')), 8000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        window.clearTimeout(timeout);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch((error) => {
      privacyPromise = undefined;
      throw error;
    });
    return privacyPromise;
  }

  function updateEmbeds(api) {
    const consent = api.currentVisitorConsent();
    const allowed = consent.marketing === 'yes' && api.marketingAllowed();
    document.querySelectorAll('[data-da-consent-embed]').forEach((wrapper) => {
      const frame = wrapper.querySelector('iframe[data-da-consent-src]');
      const placeholder = wrapper.querySelector('[data-da-consent-placeholder]');
      if (!frame) return;
      if (allowed) {
        if (frame.getAttribute('src') !== frame.dataset.daConsentSrc) frame.setAttribute('src', frame.dataset.daConsentSrc);
      } else {
        frame.removeAttribute('src');
      }
      frame.hidden = !allowed;
      if (placeholder) placeholder.hidden = allowed;
    });
  }

  function showFallback() {
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    fields.disabled = true;
    status.textContent = dialog.dataset.loading;
    loadPrivacy().then((api) => {
      const consent = api.currentVisitorConsent();
      ['preferences', 'analytics', 'marketing'].forEach((key) => {
        form.elements.namedItem(key).checked = consent[key] === 'yes';
      });
      fields.disabled = false;
      status.textContent = '';
      updateEmbeds(api);
    }).catch(() => {
      status.textContent = dialog.dataset.error;
    });
  }

  function openPreferences() {
    previousFocus = document.activeElement;
    if (window.privacyBanner?.showPreferences) {
      try {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(showFallback);
        return;
      } catch {
        showFallback();
        return;
      }
    }
    showFallback();
  }

  function saveConsent(choice) {
    fields.disabled = true;
    status.textContent = dialog.dataset.loading;
    const consent = {};
    ['preferences', 'analytics', 'marketing'].forEach((key) => {
      consent[key] = choice === 'accept' || (choice !== 'reject' && form.elements.namedItem(key).checked);
    });
    loadPrivacy().then((api) => {
      let completed = false;
      const timeout = window.setTimeout(() => {
        if (completed) return;
        status.textContent = dialog.dataset.error;
        fields.disabled = false;
      }, 8000);
      try {
        api.setTrackingConsent(consent, () => {
          completed = true;
          window.clearTimeout(timeout);
          ['preferences', 'analytics', 'marketing'].forEach((key) => {
            form.elements.namedItem(key).checked = consent[key];
          });
          fields.disabled = false;
          status.textContent = dialog.dataset.saved;
          updateEmbeds(api);
        });
      } catch {
        completed = true;
        window.clearTimeout(timeout);
        status.textContent = dialog.dataset.error;
        fields.disabled = false;
      }
    }).catch(() => {
      status.textContent = dialog.dataset.error;
      fields.disabled = false;
    });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-da-privacy-open]');
    if (opener) {
      event.preventDefault();
      openPreferences();
    }
    if (event.target.closest('[data-da-privacy-close]')) dialog?.close();
    const choice = event.target.closest('[data-da-privacy-choice]');
    if (choice && !fields.disabled) saveConsent(choice.dataset.daPrivacyChoice);
  });
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!fields.disabled) saveConsent('save');
  });
  dialog?.addEventListener('close', () => previousFocus?.focus());
  document.addEventListener('visitorConsentCollected', () => loadPrivacy().then(updateEmbeds).catch(() => {}));
  document.addEventListener('shopify:section:load', () => loadPrivacy().then(updateEmbeds).catch(() => {}));
  loadPrivacy().then(updateEmbeds).catch(() => {});
})();
